export const GetWorkOrderScreenHeader = (id: string) => ({
  previousTab: {title: 'Work Orders', routeName: 'list'},
  tabs: [
    {title: 'Record View', routeName: 'recordView', params: {id}},
    {title: 'Labour', routeName: 'labour', params: {id}},
    {title: 'Work Log', routeName: 'workLog', params: {id}},
    {title: 'Assets', routeName: 'assets', params: {id}},
  ]
})
